import Api from "./baseApi";

export default {
  getCostTable: (q, categoryId) => {
    let url = "/api/mpproducts/cost-table?v=1";
    if (q) url += `&q=${encodeURIComponent(q)}`;
    if (categoryId != null && categoryId > 0) url += `&categoryId=${categoryId}`;
    return Api.get(url);
  },
  updateMultiplier: body =>
    Api.post("/api/mpproducts/cost-table/update-multiplier", body)
};
